export default "__VITE_ASSET__ahxe1qS$__";